export default __webpack_public_path__ + "static/media/google.062d1225.svg";